import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {VetDoctor} from "../../models/vet-clinic.model";
import {VetDoctorVetVisitType, VetineoVisitTypeMinutes} from "../../models/vet-doctor-vet-visit-type.model";
import {AppStateService} from "../../providers/app-state.service";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {CommonUtils} from "../../utils/common";
import {VetineoVisitTypeBundleService} from "../../providers/vetineo-visit-type-bundle.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-list-visit-types-details',
  templateUrl: './list-visit-types-details.component.html',
  styleUrls: ['./list-visit-types-details.component.scss'],
})
export class ListVisitTypesDetailsComponent implements OnInit {

  @Input()
  doctorsVisitTypeMaps: Map<VetDoctor, VetDoctorVetVisitType[]>;

  @Input()
  doctorsSelected: VetDoctor[];
  minutes: number;
  regex = new RegExp('^\\d+(\\.\\d{1,2})?$');
  decimalPlacesRegex = new RegExp('^\\d+(\\.\\d{2})');
  cancellationHoursToSelect: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 16, 24, 36, 48, 72, 96];
  @Output() objectAddedEmitter = new EventEmitter<boolean>();
  @Output() actionCanceledEmitter = new EventEmitter<boolean>();
  private subscriptions: Subscription = new Subscription();


  constructor(private appStateService: AppStateService,
              private vetClinicService: VetClinicService, private commonUtils: CommonUtils,
              private vetineoVisitTypeBundleService: VetineoVisitTypeBundleService) {
  }

  ngOnInit() {


  }

  getMinutesAvailable(doctor: VetDoctor) {
    return this.minutesAvailable(doctor.defaultVisitMinutes);
  }

  private minutesAvailable(minutes: number): number[] {
    if (minutes) {
      return Object.values(VetineoVisitTypeMinutes)?.filter(value => typeof value === "number" && (value % minutes) === 0) as number[];
    } else {
      return [];
    }
  }

  onMinutesChange(vetDoctorVetVisitType) {
    vetDoctorVetVisitType.minutes = this.minutes;
  }


  handleVisitTypePrepaidToggle(vetDoctorVetVisitType, event: any) {
    if (event.detail.checked) {
      vetDoctorVetVisitType.prepaidRequired = true;
    } else {
      vetDoctorVetVisitType.prepaidRequired = false;
    }
  }

  handleVisitTypePrepaidPriceChange(vetDoctorVetVisitType, event: any) {
    let eventString: string = event.detail.value.replace(/,/g, '.');
    eventString = eventString.replace(/[^\d]/g, '');
    eventString = eventString.replace(/^0\d+/g, '0');
    eventString = eventString.replaceAll(/^\./g, '');
    eventString = eventString.replace(/\.\d*\./g, '.');
    eventString = eventString.replaceAll('-', '');

    const price = (Number.isNaN(eventString) ? 0 : Number.parseFloat(eventString));
    if (price) {
      vetDoctorVetVisitType.prepaidPrice = price;
    }
  }

  handleEditTermCanBeCancelledToggle(vetDoctorVetVisitType, $event) {
    if ($event.detail.checked) {
      vetDoctorVetVisitType.termCanBeCancelled = true;
    } else {
      vetDoctorVetVisitType.termCanBeCancelled = false;
    }
  }

  handleRequreCancellationReasonToggle(vetDoctorVetVisitType, $event) {
    if ($event.detail.checked) {
      vetDoctorVetVisitType.requireCancellationReason = true;
    } else {
      vetDoctorVetVisitType.requireCancellationReason = false;
    }
  }

  onSelectHoursToCancellation(vetDoctorVetVisitType, $event) {
    vetDoctorVetVisitType.maxTermCancellation = $event.detail.value;
  }

  onChangeUseBundleSettingsCheckbox(vetDoctorVetVisitType, $event) {
    console.log($event)
    if ($event.detail.checked) {
      vetDoctorVetVisitType.useBundleSettings = true;
    } else {
      vetDoctorVetVisitType.useBundleSettings = false;
    }
  }

  registerSubscription(sub: Subscription) {
    if (sub) {
      this.subscriptions.add(sub);
    }
  }

  onAdd() {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie',
      'checkmark', 'close', () => {
        this.appStateService.updateIsBusySubject(true);
        let listOfValues = [];
        this.doctorsVisitTypeMaps.values();

        console.log(this.doctorsVisitTypeMaps)

        for (const value of this.doctorsVisitTypeMaps.values()) {
          let visitTypes = value.map(e => {
            e.vetDoctor = null;
            e.vetineoVisitTypeBundle = null;
            return e;
          });
          listOfValues.push(...visitTypes);
        }

        this.registerSubscription(this.vetineoVisitTypeBundleService.addMultipleBundlesForMultipleDoctors(listOfValues).subscribe(e => {
            this.appStateService.updateIsBusySubject(false);
            if (e) {

              this.commonUtils.presentInfoToast('Typy wizyt zostały dodane');
              this.objectAddedEmitter.emit(true)
            } else {
              this.commonUtils.presentAlertToast('Wsytąpił błąd podczas dodawania typów wizyt');
            }
          },
          error => {
            this.commonUtils.presentAlertToast('Wsytąpił błąd podczas dodawania typów wizyt');
            this.appStateService.updateIsBusySubject(false);
          }
        ));
      }
      , () => {
      });
  }

  onCancel() {
    this.actionCanceledEmitter.emit(null);
  }

}
